import { render, staticRenderFns } from "./InspectionTooltip.vue?vue&type=template&id=37fda5af&scoped=true"
import script from "./InspectionTooltip.vue?vue&type=script&lang=js"
export * from "./InspectionTooltip.vue?vue&type=script&lang=js"
import style0 from "./InspectionTooltip.vue?vue&type=style&index=0&id=37fda5af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fda5af",
  null
  
)

export default component.exports